import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import {
  BuilderMenu,
  DefaultVariableResult,
  VariableSelectFeatureFlag,
  VariableTextFeatureFlag,
} from '@makyoapp/makyo-common'
import { Field } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useVariableTextEdit } from '@/hooks/useVariableTextEdit'
import { AccordionItem } from '@/components/Accordion/Accordion'
import { VariableSelectV2 } from '@/components/VariableSelectV2/VariableSelectV2'
import { VariableTextV2 } from '@/components/VariableTextV2/VariableTextV2'

/**
 * MenuItemSettingAccordion is a function component that provides an interface for editing the settings of a menu item in a builder.
 */
function MenuItemSettingAccordion({
  menu,
  menuIdx,
  menuItemIdx,
}: {
  menuIdx: number
  menu: BuilderMenu
  menuItemIdx: number
}) {
  const { updateMenu } = useAppBuilderContext()

  // handle menu item title with variable text support
  const [variableMenuItemTitle, setVariableMenuItemTitle] = useVariableTextEdit({
    value: menu.items[menuItemIdx].title,
    onChange: (value) => {
      updateMenu(menuIdx, (prev) => {
        prev.items[menuItemIdx].title = value
      })
    },
  })

  // The menu item settings editing interface
  return (
    <AccordionItem itemId={'menu-item-settings'} title={<Trans>Menu Item Settings</Trans>}>
      <Field isVertical>
        <label>
          <Trans>Title</Trans>
        </label>
        <div className='w-full'>
          <VariableTextV2
            id={`menu-item-${menuItemIdx}-title`}
            value={variableMenuItemTitle}
            onChange={setVariableMenuItemTitle}
            featureFlags={VariableTextFeatureFlag.SingleCell | VariableTextFeatureFlag.ProfileData}
            variableColumnOptions={{
              columnTypes: [ColumnTypes.Text],
            }}
          />
        </div>
        {/* <SimpleInput
          value={tempTitle}
          onChange={(e) => {
            const value = e.currentTarget.value
            setTempTitle(value)
          }}
          onBlur={async () => {
            setTempTitle(tempTitle.trim())
            await updateMenu(menuIdx, (prev) => {
              prev.items[menuItemIdx].title = tempTitle.trim()
            })
          }}
        /> */}
      </Field>
      <Field isVertical>
        <label>
          <Trans>Media</Trans>
        </label>
        <VariableSelectV2
          id={`menu-item-${menuItemIdx}-icon`}
          value={menu.items[menuItemIdx].icon}
          featureFlags={
            VariableSelectFeatureFlag.Avatar | VariableSelectFeatureFlag.Icon | VariableSelectFeatureFlag.Image
          }
          onChange={async (opt) => {
            await updateMenu(menuIdx, (prev) => {
              prev.items[menuItemIdx].icon = opt as DefaultVariableResult
            })
          }}
        />
      </Field>
      {/*
         <Field isVertical>
         <label>
         <Trans>Active Icon / Avatar</Trans>{' '}
         <span className='text-light'>
         <Trans>(optional)</Trans>
         </span>
         </label>
         <VariableSelect
         value={menu.items[menuItemIdx].iconActive}
         featureFlags={VariableFeatureFlag.Avatar | VariableFeatureFlag.Icon}
         onChange={async (opt) => {
         await updateMenuAlt(menuIdx, (prev) => {
         prev.items[menuItemIdx].iconActive = opt as DefaultVariableResult
         })
         }}
         ></VariableSelect>
         </Field>
         */}
    </AccordionItem>
  )
}

export default MenuItemSettingAccordion
